<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="globe"/>
          {{ $t('title') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <client-select class="mr-1 mb-1" :model="filterFormModel" attribute="client" @change="search"
                           :isFilter="true" :place-holder="$t('selectClient') "></client-select>
            <form-input :model="filterFormModel" attribute="number" class="mr-1 mb-1" :placeholder="$t('inputNumber')"></form-input>
            <gateway-select :model="filterFormModel" attribute="gateway" class="mr-1 mb-1"></gateway-select>
            <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="month" :options="[
                {value: null, text: $t('chooseMonth')},
                {value: 1, text: 1},
                {value: 2, text: 2},
                {value: 3, text: 3},
                {value: 4, text: 4},
                {value: 5, text: 5},
                {value: 6, text: 6},
                {value: 7, text: 7},
                {value: 8, text: 8},
                {value: 9, text: 9},
                {value: 10, text: 10},
                {value: 11, text: 11},
                {value: 12, text: 12},
            ]"></form-select>
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.year" v-on:keydown.enter="load"
                          :placeholder="$t('year')"></b-form-input>
            <time-range-picker :model="filterFormModel" class="mr-1 mb-1" :label="$t('chargedTime')"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>

            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row">
            <div class="col-10">
              <b class="text-info text-right">{{ $t('total') }}</b>
            </div>
            <div class="col-2"><b-spinner v-if="totalLoading" small></b-spinner><span v-else>{{ total | numFormat }}</span></div>
          </div>
          <div class="row c-smart-table__title">
            <div class="col-lg-4">{{ $t('client') }}</div>
            <div class="col-lg-3">{{ $t('phone') }}</div>
            <div class="col-lg-3">{{ $t('time') }}</div>
            <div class="col-lg-2">{{ $t('amount') }}</div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-4">
              <b class="c-smart-table__label">{{ $t('client') }}: </b>
              <span>{{ item.client.companyName }} ({{ item.client.domain }})</span>
            </div>
            <div class="col-lg-3">
              <div>
                <b>{{ $t('phone') }}:&nbsp;</b>
                <span v-if="item.number && item.number.number">{{ $t(item.number.number) }}</span>
                <span v-else>{{$t('noInfo')}}</span>
              </div>
              <div>
                <b>Gateway:&nbsp;</b>
                <span v-if="item.gateway">{{ $t(item.gateway.name) }}</span>
                <span v-else class="text-gray-999">{{$t('noInfo')}}</span>
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <b>{{ $t('month') }}: </b>
                <span>{{ item.month }}/{{ item.year }}</span>
              </div>
              <div>
                <b>{{ $t('chargedTime') }}: </b>
                <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </div>
            </div>
            <div class="col-lg-2">
              <p>
                <b class="c-smart-table__label">{{ $t('amount') }}: </b>
                <span>{{ item.amount | numFormat }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>

<script>
import List from "@/mixins/List";
import ClientSelect from "../../components/ClientSelect";
import TimeRangePicker from "@/components/TimeRangePicker";
import _ from 'lodash';
import GatewaySelect from "@/components/GatewaySelect";

export default {
  components: {
    GatewaySelect,
    ClientSelect, TimeRangePicker
  },
  mixins: [List],
  data: function () {
    return {
      service: '/phone-number-subscription-transaction',
      autoLoad: true,
      defaultFilterFormModel: {
        month: null,
        year: null,
        type: null,
        gateway: null
      },
      total: 0,
      totalLoading: false
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    load: _.debounce(function () {
      let loader = this.$loading.show();
      this.$service.get(this.service, {
        params: this.filterFormModel
      }).then(response => {
        this.apply(response.data);
        this.sum();
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        loader.hide();
      });
    }, 200, {leading: true, trailing: false}),
    sum: function () {
      this.totalLoading = true;
      this.$bgService.get(this.service + "/sum", {params: this.filterFormModel}).then(response => {
        this.total = response.data && response.data.length > 0 ? response.data[0].total : 0;
      }).finally(()=> {
        this.totalLoading = false
      });
    },
  },
  i18n: {
    messages: {
      en: {
        title: 'Phone number subscription transaction',
        month: 'Month',
        year: 'Year',
        amount: 'Amount',
        chargedTime: 'Charged time',
        time: 'Time',
        number: 'Phone number',
        chooseMonth: 'Choose month',
        item: 'Item',
        phoneSubscription: 'Phone number subscription fee',
        inputNumber: 'Input number',
        noInfo: 'No info',
        chooseGateway: 'Choose gateway name'
      },
      vi: {
        title: 'Phí duy trì số điện thoại',
        month: 'Tháng',
        year: 'Năm',
        amount: 'Số tiền',
        chargedTime: 'Tính tiền lúc',
        time: 'Thời gian',
        number: 'Số điện thoại',
        chooseMonth: 'Chọn tháng',
        phoneSubscription: 'Phí thuê bao điện thoại',
        inputNumber: 'Nhập số điện thoại',
        noInfo: 'Không có thông tin',
        chooseGateway: 'Chọn tên gateway'
      }
    }
  }
}
</script>